
import { default as axios } from 'axios';
import { Component } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { State } from 'vuex-class';
import { IAccountHyperMediaRepresentation } from '../../shared/contracts/AccountContract';
import { AnswerType, IAnswerHypermediaRepresentation } from '../../shared/contracts/AnswerContract';
import { ISnapshotHypermediaRepresentation } from '../../shared/contracts/SnapshotContract';
import { performance } from '../../shared/services/PerformanceService';
import { IGroupDetailsState } from '../../store/contract';
import store from '../../store/store';
import GroupDetailsBase from './GroupDetailsBase.vue';

@Component({})
export default class SectorDetails extends GroupDetailsBase {

    @State('details') groupDetailState: IGroupDetailsState;

    async beforeRouteEnter(to: Route, from: Route, next: Function) {
        performance.track(`sector-details-${(to.params as any).id}`);
        await store.dispatch('details/fetchSectorAggregate', (to.params as any).id);
        next();
    }

    markPerformance() {
        this.$nextTick(function() {
            performance.end(`sector-details-${this.id}`);
        });
    }

    protected relevantAnswerInSnapshot(answer: IAnswerHypermediaRepresentation, accounts: IAccountHyperMediaRepresentation[]): boolean {
        const sectorId = this.groupDetailState.aggregate.itemId;
        if ((answer.answerType !== AnswerType.Project) && (answer.answerType !== AnswerType.Rotation)) {return true;}
        return (accounts.find(a =>  a.accountId === answer.accountId).sectorId === sectorId);
    }

    protected async filterAnswersFromSnapshots(snapshots: ISnapshotHypermediaRepresentation[]): Promise<ISnapshotHypermediaRepresentation[]> {
        const url = `${store.state.root._links.accounts.href}`;
        const accounts = (await axios.get<IAccountHyperMediaRepresentation[]>(url)).data;
        return snapshots.map(snapshot => ({
            ...snapshot,
            answers: snapshot.answers.filter(a => this.relevantAnswerInSnapshot(a, accounts))
        }));
    }
}
